@let header = globalDataService.config().header;
<div
  class="page-content"
  [class.page-content--admin-mode]="adminMode"
  [class.is-scrolling]="isScrolling"
  [class.has-topper]="header.data.headerTopper.display"
>
  <app-header
    [styles]="header.data.styles"
    [logoDisplay]="header.data.logo.display"
    [logoSrc]="header.data.logo.src_data"
    [logoRedirect]="header.data.logo.redirect"
    [topperDisplay]="header.data.headerTopper.display"
    [topperPhone]="header.data.headerTopper.phone"
    [menuItems]="header.data.menu ?? defaultHeaderMenuItems"
  ></app-header>

  <!-- Dynamic Component Loop -->
  @for (component of orderedComponents(); track $index) {
    @if ($index > 1) {
      @defer {
        <ng-container
          [ngTemplateOutlet]="getTemplate(component.componentType)"
          [ngTemplateOutletContext]="{
            instanceKey: component.instanceKey,
            config: component.config,
            orderIndex: $index,
          }"
        />
      }
    } @else {
      <ng-container
        [ngTemplateOutlet]="getTemplate(component.componentType)"
        [ngTemplateOutletContext]="{
          instanceKey: component.instanceKey,
          config: component.config,
          orderIndex: $index,
        }"
      />
    }
  }

  @defer {
    @let footer = globalDataService.config().footer;
    <app-footer
      [config]="footer"
    />
  }

  <!-- Component Templates -->
  <ng-template #heroBannerTemplate let-instanceKey="instanceKey" let-config="config">
    <app-hero-banner
      [instanceKey]="instanceKey"
      [enabled]="!!config?.enabled"
      [styles]="config?.data?.styles"
      [quantity]="config?.data?.quantity || 5"
      [imageToggle]="config?.data?.imageToggle"
      [imageSrcData]="config?.data?.imageSrcData"
      [bannerSize]="config?.data?.bannerSize || 'large'"
      [mainText]="config?.data?.mainText"
      [mainTextSize]="config?.data?.mainTextSize"
      [subText]="config?.data?.subText"
      [ctaText]="config?.data?.ctaText"
      [bannerAltText]="config?.data?.bannerAltText"
    ></app-hero-banner>
  </ng-template>

  <ng-template #featuredCarouselTemplate let-config="config" let-orderIndex="orderIndex">
    <app-featured-carousel
      [enabled]="!!config?.enabled"
      [quantity]="config?.data?.quantity || 6"
      [currencyCode]="globalData.selectedCurrency().code"
      [assetCardDefaultImage]="globalData.defaultImage()"
      [assetCardConfig]="config?.data?.components?.assetCard"
      (cardClick)="cardClicked($event)"
      (contactClick)="contactClicked($event)"
      [orderIndex]="orderIndex"
    ></app-featured-carousel>
  </ng-template>

  <ng-template #browseByCategoryTemplate let-config="config">
    <app-browse-by-category
      [enabled]="!!config?.enabled"
      [styles]="config?.data?.styles"
      [quantity]="config?.data?.quantity"
      [display]="config?.data?.display"
    ></app-browse-by-category>
  </ng-template>

  <ng-template #browseByMakeTemplate let-config="config">
    <app-browse-by-make
      [enabled]="!!config?.enabled"
      [styles]="config?.data?.styles"
      [quantity]="config?.data?.quantity"
      [showImages]="config?.data?.display"
    ></app-browse-by-make>
  </ng-template>

  <ng-template #contactFormSectionTemplate let-instanceKey="instanceKey" let-config="config">
    <app-section
      [enabled]="!!config?.enabled"
      [mainText]="config?.data?.mainText"
      [mainTextSize]="config?.data?.mainTextSize"
      [subText]="config?.data?.subText"
      [styles]="config?.data?.styles"
      [colorScheme]="'contactForm.main'"
    >
      @let generalConfig = globalDataService.config().general;
      @let contactFormConfig = globalDataService.config().contactForm;
      <app-contact-form
        [withCloseButton]="false"
        [successTitle]="contactFormConfig?.data?.successTitle"
        [successBody]="contactFormConfig?.data?.successBody"
        [acknowledgementEnabled]="generalConfig?.data?.contact_form_acknowledgement_enabled ?? false"
        [customAcknowledgementText]="generalConfig?.data?.custom_acknowledgement_text ?? ''"
      ></app-contact-form>
    </app-section>
  </ng-template>
</div>